export const sharePopUpInitialValues = {
  memberName: "",
  senderMessage: "",
};
